<template>
    <tr>
        <td> {{ item.date }}</td>
        <td> {{ item.bill_number }}</td>
        <td class="text-right"> {{ item.total_amount }}</td>
        <td class="text-right">
          <div class="d-flex justify-content-end">
            <input
                v-model="item.vds_payable_amount"
                type="number" class="form-control text-right"
                style="width: 100px"
            >
          </div>
        </td>
        <td class="text-right">
          <div class="d-flex justify-content-end">
            <input
                v-model="item.tds_payable_amount"
                type="number" class="form-control text-right"
                style="width: 100px"
            >
          </div>
        </td>
        <td class="text-right">
          <div class="d-flex justify-content-end">
            <input
                v-model="item.discount_receipt_amount"
                type="number" class="form-control text-right"
                style="width: 100px"
            >
          </div>
        </td>
        <td class="text-right"> {{ item.paid_amount }}</td>
        <td class="text-right"> {{ item.adjustment_amount }}</td>
        <td class="text-right"> {{ commaFormat(getDue) }}</td>
        <td class="text-right">
            <div class="d-flex justify-content-end">
                <input
                    v-model="item.payment"
                    @input="checkInputValidity"
                    type="number" class="form-control text-right"
                    style="width: 100px"
                >
            </div>
        </td>
    </tr>
</template>

<script setup>
import {computed} from "vue";
import figureFormatter from "@/services/utils/figureFormatter";

const props = defineProps({
    item: Object
})
const {commaFormat} = figureFormatter()

function checkInputValidity (e) {
    if(e.target.value > props.item.due) {
        props.item.payment = props.item.due
    }
}

const getDue = computed(() => {
  const vdsValue = props.item.vds_payable_amount ? props.item.vds_payable_amount : 0;
  const aitValue = props.item.tds_payable_amount ? props.item.tds_payable_amount : 0;
  const discountValue = props.item.discount_receipt_amount ? props.item.discount_receipt_amount : 0;
  return props.item.due = props.item.total_amount - props.item.adjustment_amount - (vdsValue + aitValue + discountValue + props.item.paid_amount);
})
</script>
